import {Injectable} from "@angular/core";
import {HttpClient} from '@angular/common/http';

import {BaseService} from "app/views/base.service";
import { DataProviderFactory, DataRequest } from "../provider/data2.provider";


@Injectable()
export class ApiService extends BaseService {
	public perfomance: DataRequest;
	
	constructor(
		public http: HttpClient,
		public dpf: DataProviderFactory,
	) {
		super(http);
		
		this.perfomance = this.dpf.getNew('perfomance');
	}
}
